
































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { YKDCenterDrawer } from 'gum-ui'
import moment from 'moment'
import {
  queryTopicBankList,
  distinctCustomType,
  queryTopicBank
} from '@/api/exam/topicBank'
import TopicBank from '@/model/exam/topicBank'
import Topic from '@/model/exam/topic'

import { queryPagingTopic, queryAllTopic } from '@/api/exam/topic'
import { delHtmlTag } from '@/apps/exam/util/htmlUtil'
import TopicGroup, { TopicPart } from '@/model/exam/topicGroup'

import ExamPlan from '@/model/exam/examPlan'
@Component({
  components: { YKDCenterDrawer }
})
export default class FixedCreateTopicCenterDialog extends Vue {
  @Prop() centerDrawer?: boolean
  @Prop() private topicPart?: TopicPart
  @Prop() private localData?: any[]
  @Prop() private topicGroup?: TopicGroup
  private topicBanks: TopicBank[] = []
  private selectTopics: Topic[] = []
  private chosenTopics: Topic[] = []
  private errorText: string = 'color: #000000;'
  private selectNUmber: number = 0
  private checkList: any[] = []
  private keyword?: string = ''
  private columns = [
    {
      title: '题目',
      dataIndex: 'name'
    }
  ]
  private selectedRowKeys: any[] = []
  private data: any[] = []
  async mounted() {}
  @Watch('centerDrawer')
  async initSelectData() {
    if (
      (this.topicGroup && this.topicGroup.topicCategory === 'PROGRAM') ||
      (this.topicGroup && this.topicGroup.topicCategory === 'TEST')
    ) {
      const topicBankPage = await queryTopicBank({
        topicCategory: this.topicGroup.topicCategory,
        pageSize: 1000
      })
      this.topicBanks = topicBankPage.data!
    } else {
      const topicBankPage = await queryTopicBank({
        isFilterProgrom: true,
        pageSize: 1000
      })

      this.topicBanks = topicBankPage.data!
    }
    this.chosenTopics = []
  }
  async onChangeGroup(e: any) {
    this.selectedRowKeys = []
    if (e && e.length > 0) {
      if (!e[e.length - 1].topicNumber) {
        this.$message.error('该题库没有题目')
        this.checkList.splice(e.length - 1, 1)
        return
      }

      if (
        e[e.length - 1].topicNumber >
        Number(this.topicPart!.topicNumber!) -
          (Number(this.selectNUmber) + this.localData!.length)
      ) {
        this.$message.error('选择题库数量大于分组总题数')
        this.checkList.splice(e.length - 1, 1)
        return
      }
      let topic: Topic = {}
      topic.topicBankname = e[e.length - 1].name
      topic.selectTopicBankId = e[e.length - 1].id
      topic.topicBankNumber = e[e.length - 1].topicNumber
      this.chosenTopics.push(topic)

      if (this.chosenTopics.length > 0) {
        this.chosenTopics[
          this.chosenTopics.length - 1
        ].topicNumber = this.chosenTopics.length
        this.selectNUmber += this.chosenTopics[
          this.chosenTopics.length - 1
        ].topicBankNumber!
      } else {
        this.chosenTopics[this.chosenTopics.length - 1].topicNumber = 1
        this.selectNUmber += this.chosenTopics[e.length - 1].topicBankNumber!
      }
    }
  }
  async selectBank(topicBank: TopicBank) {
    this.selectedRowKeys = []
    const topics = await queryPagingTopic({
      topicBankId: topicBank.id,
      pageSize: 10000
    })

    this.data = []
    if (topics && topics.data && topics.data.length > 0) {
      this.selectTopics = topics.data
      topics.data.forEach((item, index) => {
        this.data.push({
          key: index,
          name: delHtmlTag(item.name!)
        })
      })
    }
  }
  onSelectChange(selectedRowKeys: any) {
    //判断是否超出已选择的数量
    if (
      Number(this.topicPart!.topicNumber!) <=
      Number(this.selectNUmber) + this.localData!.length
    ) {
      this.errorText = 'color:red;'
      return
    }
    if (Number(this.selectNUmber) + this.localData!.length === 0) {
      if (selectedRowKeys.length > Number(this.topicPart!.topicNumber!)) {
        this.errorText = 'color:red;'
        return
      }
    }
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      if (this.selectTopics && this.selectTopics.length > 0) {
        this.selectTopics.forEach((item, index) => {
          item.name = delHtmlTag(item.name!)
          if (selectedRowKeys.indexOf(index) != -1) {
            this.chosenTopics.push(item)
          }
        })
      }
    }
    //去重
    let newChosenTopics: Topic[] = []

    for (var i = 0; i < this.chosenTopics.length; i++) {
      if (newChosenTopics.length > 0) {
        let isNew: boolean = false
        newChosenTopics.forEach((item, index) => {
          if (item.id === this.chosenTopics[i].id) {
            isNew = true
          }
        })
        if (!isNew) {
          this.chosenTopics[i].topicNumber = newChosenTopics.length + 1
          newChosenTopics.push(this.chosenTopics[i])
        }
      } else {
        this.chosenTopics[i].topicNumber = 1
        newChosenTopics.push(this.chosenTopics[i])
      }
    }
    this.chosenTopics = newChosenTopics
    this.selectNUmber = this.chosenTopics.length
    this.selectedRowKeys = selectedRowKeys
  }
  deleteTopic(topic: Topic) {
    if (this.chosenTopics && this.chosenTopics.length > 0) {
      this.chosenTopics.forEach((item, index) => {
        if (topic.id === item.id) {
          this.chosenTopics.splice(index, 1)
        }
      })

      this.chosenTopics.forEach((item, index) => {
        item.topicNumber = index + 1
      })
    }
    this.selectNUmber = this.chosenTopics.length
    console.log(this.selectNUmber, 'mmmmmmmmmm')
    console.log(
      Number(this.selectNUmber) + this.localData!.length,
      'axxxxxxxxxx'
    )
    if (
      this.selectNUmber <=
      Number(this.selectNUmber) + this.localData!.length
    ) {
      this.errorText = 'color: #000000;'
    }
    this.selectedRowKeys = []
  }
  //筛选
  async handleSearch(e: any) {
    if (e) {
      let newTopics: Topic[] = []
      this.selectTopics.forEach((item, index) => {
        if (item.name) {
          if (item.name.match(e)) {
            newTopics.push(item)
          }
        }
      })
      this.data = []
      for (let i = 0; i < newTopics.length; i++) {
        this.data.push({
          key: newTopics[i].id,
          name: newTopics[i].name
        })
      }
    } else {
      this.data = []
      for (let i = 0; i < this.selectTopics!.length; i++) {
        this.data.push({
          key: this.selectTopics![i].id,
          name: this.selectTopics![i].name
        })
      }
    }
  }
  clear() {
    this.errorText = 'color: #000000;'
    this.selectedRowKeys = []
    this.chosenTopics = []
    this.selectNUmber = this.chosenTopics.length
  }
  closeCenter() {
    this.selectedRowKeys = []
    this.selectNUmber = 0
    this.$emit('closeCenter')
  }
  openCenter() {
    this.$emit('centerDrawer')
  }
  confirm() {
    this.selectedRowKeys = []
    this.selectNUmber = 0
    this.$emit('confirmTopic', this.chosenTopics)
  }
}
